import { triggerFadeInExpandCollapseStatefulAnimation } from '../../../core/animations';

export const TimeSlotsByDateComponentAnimations = [triggerFadeInExpandCollapseStatefulAnimation('animatedContent')];
